/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-25 09:13:20
 */
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { NzDividerModule, NzSwitchModule } from 'ng-zorro-antd';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { DtBrowserModule } from '@ithinkdt/shared/browser';

import { LazyService } from './lazy.service';

import { SettingDrawerComponent } from './setting-drawer.component';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, DragDropModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [NzDrawerModule, NzToolTipModule, NzDividerModule, NzIconModule, NzSelectModule, NzSwitchModule];

const DT_MODULES = [DtBrowserModule];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES, ...DT_MODULES],
  declarations: [SettingDrawerComponent],
  exports: [SettingDrawerComponent],
  providers: [LazyService],
})
export class DtSettingDrawerModule {}
